import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/main.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

const pinia = createPinia()

async function arrancarAplicacion() {
    const app = createApp(App)
    app.use(pinia)

    // MSAL must be initialized before the router starts its initial navigation
    const authStore = useAuthStore()
    await authStore.initialize()

    app.use(router)
    app.use(createBootstrap())
    app.mount('#app')
}

void arrancarAplicacion()
